import { render, staticRenderFns } from "./service_product.vue?vue&type=template&id=16367cfa&scoped=true"
import script from "./service_product.vue?vue&type=script&lang=js"
export * from "./service_product.vue?vue&type=script&lang=js"
import style0 from "./service_product.vue?vue&type=style&index=0&id=16367cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16367cfa",
  null
  
)

export default component.exports